import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { ActionsExecuting, actionsExecuting } from '@ngxs-labs/actions-executing';
import { Login } from '@auth/store/auth/auth.action';
import { Observable } from 'rxjs';
import { GetCatalogProviders, GetCategories } from '@shared/state/shared/shared.action';

@Component({
  selector: 'app-data-main',
  templateUrl: './data-main.component.html',
  styleUrls: ['./data-main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataMainComponent {
  @Select(actionsExecuting([Login, GetCategories, GetCatalogProviders])) public loginInProgress$: Observable<ActionsExecuting>;
  constructor(private store: Store) {
    this.store.dispatch([new GetCategories(), new GetCatalogProviders()]);
  }
}
